import * as React from 'react';

function SvgGoogleSignin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={46} height={46} viewBox="0 0 46 46" {...props}>
      <rect width={41} height={41} x={3.5} y={4} fillOpacity={0.15} rx={2} />
      <rect width={40} height={40} x={4} y={4} fill="#FFF" rx={2} />
      <path
        fill="#4285F4"
        d="M32.64 24.2c0-.63-.06-1.25-.16-1.84H24v3.48h4.84a4.14 4.14 0 01-1.8 2.72v2.26h2.92a8.78 8.78 0 002.68-6.62z"
      />
      <path
        fill="#34A853"
        d="M24 33a8.6 8.6 0 005.96-2.18l-2.91-2.26a5.4 5.4 0 01-8.09-2.85h-3v2.33A9 9 0 0024 33z"
      />
      <path
        fill="#FBBC05"
        d="M18.96 25.71a5.41 5.41 0 010-3.42v-2.33h-3a9 9 0 000 8.08l3-2.33z"
      />
      <path
        fill="#EA4335"
        d="M24 18.58c1.32 0 2.5.45 3.44 1.35l2.58-2.59a9 9 0 00-14.06 2.61l3 2.34A5.36 5.36 0 0124 18.58z"
      />
    </svg>
  );
}

export default SvgGoogleSignin;
